import {
  Box,
  Button,
  MenuItem,
  Menu,
  CircularProgress,
  Skeleton,
  Checkbox,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import styles from "./LeadReportCreation.module.css";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import CancelBtn from "../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import { useLocation, useNavigate } from "react-router-dom";
import SaveReportPopup from "../SaveReportPopup/SaveReportPopup";
import CancelModal from "../../../../../components/CancelModal/CancelModal";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PaymentStatusToggle from "./Toggle";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  findCountryByName,
  formatAmount,
  getMonths,
  getYears,
} from "../../../../../components/CommonFunctions/CommonFunctions";
import moment from "moment";
import BarChart from "../../../Dashboard/components/BarChart/BarChart";
import { useDispatch } from "react-redux";
import { useCountries } from "use-react-countries";
import {
  getReportById,
  getReportData,
  resetReportStatuses,
  resetWholeReportData,
  saveReport,
} from "../../service/reportsSlice";
import RevenuePaidTab from "./RevenuePaidTab";
import RevenueOverdueTab from "./RevenueOverdueTab";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import dayjs from "dayjs";
import clearFilterIcon from "../../../../../assets/images/clearFilter.svg";
import downloadIcon from "../../../../../assets/images/report-download.svg";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import accordionDown from "../../../../../assets/images/accordion-down.svg";
import { DownloadReport } from "../../service/reports.request";
import DashboardSkeleton from "../../../../../components/Skeletons/DashboardSkeleton";
import PageBackBtn from "../../../../../components/Buttons/PageBackBtn";
import RevenuePendingTab from "./RevenuePendingTab";
import RevenueUpcomingTab from "./RevenueUpcomingTab";
import YearMonthSelector from "./MultiSelectMonthYear";
import CustomFilterAccordion from "../../../../../components/CustomFilterAccordion/CustomFilterAccordion";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterSearchField from "../../../../../components/FilterDrawer/FilterSearchField/FilterSearchField";
import { FormGroup } from "@mui/material";

interface CheckedBranch {
  id: string;
  branchName: string;
}
interface CheckedCountry {
  name: string;
}
interface CheckedCourse {
  id: string;
  courseName: string;
}
interface CheckedBatch {
  id: string;
  batchName: string;
}
const RevenueReportCreation = (props: any) => {
  const { add } = props;
  const auth = useAuthUser();
  const user = auth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userById } = useSelector((state: any) => state.userDetails);
  const [hoveredYear, setHoveredYear] = useState<number | null>(null);
  // const [selectedMonths, setSelectedMonths] = useState<any>({});
  const [selectedMonths, setSelectedMonths] = useState<any>(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthName = currentDate.toLocaleString("default", {
      month: "long",
    }); // "November"

    return {
      [currentYear]: [currentMonthName],
    };
  });
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const { countries } = useCountries();
  const {
    saveReportLoading,
    saveReportSuccess,
    reportWholeData,
    reportDataloading,
    reportById,
    reportByIdLoading,
  } = useSelector((state: any) => state.reports);
  const { leadModalState } = useSelector((state: any) => state.nurture);
  const branches = useSelector((state: any) => state.branch.branchList);
  const courses = useSelector((state: any) => state.courses.courses);
  const batchList = useSelector((state: any) => state.batch.batchList);
  const filteredCountries = countries?.filter((country: any) =>
    branches?.some((branch: any) =>
      hasAllBranchAccess
        ? branch.country === country.name
        : branch.country === country.name && branch.id === userById?.branchId
    )
  ) || [];
  const typeOptions = [
    { id: "ACTIVE", value: "Active" },
    { id: "LOST", value: "Lost" },
  ];

  const [reportType, setReportType] = useState<string>("MONTH_LEVEL");
  const [active, setActive] = useState<number>(0);
  const [showFilters, setShowFilters] = useState<boolean>(true);
  const [checkedCountry, setCheckedCountry] = useState<CheckedCountry | null>(null);
  const [appliedCountry, setAppliedCountry] = useState<CheckedCountry | null>(null);
  const [checkedBranches, setCheckedBranches] = useState<CheckedBranch[]>([]);
  const [checkedCourses, setCheckedCourses] = useState<CheckedCourse[]>([]);
  const [checkedBatches, setCheckedBatches] = useState<CheckedBatch[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState<any[]>([]);

  const [collapseGraph, setCollapseGraph] = useState<boolean>(
    add ? false : true
  );
  const [openSaveReportPopup, setOpenSaveReportPopup] = useState(false);
  const [cancel, setCancel] = useState<boolean>(false);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // Accordion states for filters
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [isBranchOpen, setIsBranchOpen] = useState(false);
  const [isCourseOpen, setIsCourseOpen] = useState(false);
  const [isBatchOpen, setIsBatchOpen] = useState(false);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [isAdditionalPaymentOpen, setIsAdditionalPaymentOpen] = useState(false);

  const [countrySearchTerm, setCountrySearchTerm] = useState<string>("");
  const [branchSearchTerm, setBranchSearchTerm] = useState<string>("");
  const [courseSearchTerm, setCourseSearchTerm] = useState<string>("");
  const [batchSearchTerm, setBatchSearchTerm] = useState<string>("");
  const [statusSearchTerm, setStatusSearchTerm] = useState<string>("");

  const [showClearAll, setShowClearAll] = useState(false);

  const [description, setDescription] = React.useState<string>("");
  const [reportName, setReportName] = React.useState<string>("");
  const [includeAdditionaPayment, setIncludeAdditionalPayment] =
    useState(false);
  const [selectedType, setSelectedType] = useState<any[]>([...typeOptions]);
  const [filtersApplied, setFiltersApplied] = useState<boolean>(false);

  const currentDate = new Date();
  const firstDayOfMonth = dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)).startOf('day');
  const lastDayOfMonth = dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)).endOf('day');

  const [startDate, setStartDate] = useState<any>(firstDayOfMonth);
  const [endDate, setEndDate] = useState<any>(lastDayOfMonth);

  const coursesList = courses?.filter((item: any) => item?.status === "ACTIVE") || [];
  const [dontRun, setDontRun] = useState(false);
  const [prevLeadModalState, setPrevLeadModalState] = useState(false);

  const filteredBranches = branches?.filter((branch: any) => {
    const matchesBranchAccess =
      hasAllBranchAccess || branch?.id === userById?.branchId;

    const matchesCheckedCountry =
      !checkedCountry || checkedCountry?.name === branch?.country;

    return matchesBranchAccess && matchesCheckedCountry;
  }) || [];

  const filteredBatch = batchList?.filter((batch: any) => {
    const matchesBranchAccess =
      hasAllBranchAccess || batch?.branchId === userById?.branchId;

    const isValidBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      /* batch.batchStatus === 'COMPLETED' && */
      batch.batchStatus !== "CANCELLED" &&
      batch.status === "ACTIVE";

    const matchesSelectedBranches =
      checkedBranches?.length === 0 ||
      checkedBranches?.some((branch: any) => branch?.id === batch?.branchId);
    const matchesSelectedCourses =
      checkedCourses?.length === 0 ||
      checkedCourses?.some((item: any) => item?.id === batch?.courseId);

    return (
      matchesBranchAccess &&
      isValidBatch &&
      matchesSelectedBranches &&
      matchesSelectedCourses
    );
  }) || [];

  const filteredCountriesForSearch = filteredCountries?.filter((country: any) =>
    country.name.toLowerCase().includes(countrySearchTerm.toLowerCase())
  ) || [];

  const filteredBranchesForSearch = filteredBranches?.filter((branch: any) =>
    branch.branchName.toLowerCase().includes(branchSearchTerm.toLowerCase())
  ) || [];

  const filteredCoursesForSearch = coursesList?.filter((course: any) =>
    course.courseName.toLowerCase().includes(courseSearchTerm.toLowerCase())
  ) || [];

  const filteredBatchForSearch = filteredBatch?.filter((batch: any) =>
    batch.batchName.toLowerCase().includes(batchSearchTerm.toLowerCase())
  ) || [];

  const filteredStatusForSearch = typeOptions?.filter((status: any) =>
    status.value.toLowerCase().includes(statusSearchTerm.toLowerCase())
  ) || [];

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value: any) => {
    setAnchorEl(null);
  };
  const handleReportType = (value: any) => {
    if (value) {
      setReportType(value);
      if (value === "BATCH_LEVEL" && active === 3) {
        setActive(0);
      }

      if (value === "BATCH_LEVEL") {
        setFiltersApplied(false);
        setCollapseGraph(false);
      } else if (value === "MONTH_LEVEL") {
        const currentDate = new Date();
        const firstDayOfMonth = dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)).startOf('day');
        const lastDayOfMonth = dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)).endOf('day');

        setStartDate(firstDayOfMonth);
        setEndDate(lastDayOfMonth);

        if (branches?.length && userById?.branchId) {
          const getBranch = branches.find(
            (item: any) => item.id === userById.branchId
          );

          if (getBranch) {
            const branchCountry = getBranch.country;
            setCheckedCountry({ name: branchCountry });
            setAppliedCountry({ name: branchCountry });

            const computedBranches = branches?.filter((branch: any) => {
              const matchesBranchAccess =
                hasAllBranchAccess || branch?.id === userById?.branchId;
              const matchesCountry = branch?.country === branchCountry;
              return matchesBranchAccess && matchesCountry;
            }) || [];

            const allBranches = computedBranches.map((d: any) => ({
              id: d.id,
              branchName: d.branchName,
            }));
            setCheckedBranches(allBranches);

            setSelectedType([...typeOptions]);

            setCheckedBatches([]);
            setCheckedCourses([]);
            setSelectedYear([]);
            setSelectedMonth([]);
            setSelectedMonths({});
            setIncludeAdditionalPayment(false);

            const data = {
              reportType: "REVENUE",
              instituteId: activeInstitute?.id,
              generateReports: true,
              branchId: "ALL",
              reportSubType: "MONTH_LEVEL",
              branchCountry: branchCountry,
              startDate: firstDayOfMonth.valueOf(),
              endDate: lastDayOfMonth.valueOf(),
              includeRandomPayment: false,
              enquiryStatus: ["ACTIVE", "LOST"],
            };

            if (hasAllBranchAccess) {
              dispatch<any>(getReportData(data));
            } else {
              const ownBranchData = {
                ...data,
                branchId: allBranches.map((d: any) => d.id),
              };
              dispatch<any>(getReportData(ownBranchData));
            }

            setFiltersApplied(true);
          }
        } else {
          setSelectedType([...typeOptions]);
          setCheckedBatches([]);
          setCheckedCourses([]);
          setSelectedYear([]);
          setSelectedMonth([]);
          setSelectedMonths({});
          setIncludeAdditionalPayment(false);
        }
      }
    }

    if (value === "BATCH_LEVEL") {
      dispatch(resetWholeReportData());
      setCheckedCountry(null);
      setCheckedBranches([]);
      setCheckedBatches([]);
      setCheckedCourses([]);
      setSelectedYear([]);
      setSelectedMonth([]);
      setSelectedType([]);
      setIncludeAdditionalPayment(false);
      setSelectedMonths({});
      setStartDate(null);
      setEndDate(null);
    }

    setCountrySearchTerm("");
    setBranchSearchTerm("");
    setCourseSearchTerm("");
    setBatchSearchTerm("");
    setStatusSearchTerm("");

    setIsCountryOpen(false);
    setIsBranchOpen(false);
    setIsCourseOpen(false);
    setIsBatchOpen(false);
    setIsStatusOpen(false);
    setIsDateOpen(false);
    setIsAdditionalPaymentOpen(false);
    setAnchorEl(null);
  };

  const onBranchChange = React.useCallback((event: any, items: any) => {
    setCheckedBranches(Array.isArray(items) ? items : items ? [items] : []);
    setCheckedCourses([]);
    setCheckedBatches([]);
  }, []);

  const onSingleBranchChange = React.useCallback(
    (event: any, value: any | any[]) => {
      if (Array.isArray(value) && value?.length > 1) {
        setCheckedBranches([value[value.length - 1]]);
      } else {
        setCheckedBranches(value ? value : []);
      }
      setCheckedBatches([]);
    },
    []
  );

  const onCountryChange = React.useCallback(
    (event: any, value: any | any[]) => {
      setCheckedCountry(value ? { name: value.name } : null);
      setCheckedBranches([]);
      setCheckedBatches([]);
      setCheckedCourses([]);
    },
    []
  );
  // const onYearChange = React.useCallback((event: any, value: any) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setSelectedYear([value[value.length - 1]]);
  //   } else {
  //     setSelectedYear(value ? value : []);
  //   }
  // }, []);

  // const onMonthChange = React.useCallback((event: any, value: any) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setSelectedMonth([value[value.length - 1]]);
  //   } else {
  //     setSelectedMonth(value ? value : []);
  //   }
  // }, []);

  // const onBatchChange = React.useCallback((event: any, value: any | any[]) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setCheckedBatches([value[value.length - 1]]);
  //   } else {
  //     setCheckedBatches(value ? value : []);
  //   }
  // }, []);

  // const onCourseChange = React.useCallback((event: any, value: any | any[]) => {
  //   if (Array.isArray(value) && value?.length > 1) {
  //     setCheckedCourses([value[value.length - 1]]);
  //   } else {
  //     setCheckedCourses(value ? value : []);
  //   }
  //   setCheckedBatches([]);
  // }, []);

  const onYearChange = React.useCallback((event: any, items: any[]) => {
    setSelectedYear((prev: any[]) => {
      const newItemsMap = new Map(items?.map((item: any) => [item, item]));
      return prev
        ?.filter((item) => newItemsMap.has(item))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem === item)
          )
        );
    });
  }, []);

  const onMonthChange = React.useCallback((event: any, items: any[]) => {
    setSelectedMonth((prev: any[]) => {
      const newItemsMap = new Map(items?.map((item: any) => [item, item]));
      return prev
        ?.filter((item) => newItemsMap.has(item))
        ?.concat(
          items.filter(
            (item: any) => !prev.some((prevItem) => prevItem === item)
          )
        );
    });
  }, []);

  const onBatchChange = React.useCallback((event: any, items: any[]) => {
    setCheckedBatches(Array.isArray(items) ? items : items ? [items] : []);
  }, []);

  const onCourseChange = React.useCallback((event: any, items: any[]) => {
    setCheckedCourses(Array.isArray(items) ? items : items ? [items] : []);
    setCheckedBatches([]);
  }, []);

  const handleFilterCountryChecked = (id: string, name: string) => {
    setCheckedCountry({ name });
    setCheckedBranches([]);
    setCheckedBatches([]);
    setCheckedCourses([]);
  };

  const handleFilterBranchChecked = (id: string, branchName: string) => {
    if (id === "0") {
      // "All" option
      setCheckedBranches(
        checkedBranches.length === (filteredBranches?.length || 0)
          ? []
          : (filteredBranches || []).map((branch: any) => ({ id: branch.id, branchName: branch.branchName }))
      );
    } else {
      const isChecked = checkedBranches.some((branch) => branch.id === id);
      if (isChecked) {
        setCheckedBranches(checkedBranches.filter((branch) => branch.id !== id));
      } else {
        setCheckedBranches([...checkedBranches, { id, branchName }]);
      }
    }
    setCheckedBatches([]);
  };

  const handleFilterCourseChecked = (id: string, courseName: string) => {
    if (id === "0") {
      // "All" option
      setCheckedCourses(
        checkedCourses.length === (coursesList?.length || 0)
          ? []
          : (coursesList || []).map((course: any) => ({ id: course.id, courseName: course.courseName }))
      );
    } else {
      const isChecked = checkedCourses.some((course) => course.id === id);
      if (isChecked) {
        setCheckedCourses(checkedCourses.filter((course) => course.id !== id));
      } else {
        setCheckedCourses([...checkedCourses, { id, courseName }]);
      }
    }
    setCheckedBatches([]);
  };

  const handleFilterBatchChecked = (id: string, batchName: string) => {
    if (id === "0") {
      // "All" option
      setCheckedBatches(
        checkedBatches.length === (filteredBatch?.length || 0)
          ? []
          : (filteredBatch || []).map((batch: any) => ({ id: batch.id, batchName: batch.batchName }))
      );
    } else {
      const isChecked = checkedBatches.some((batch) => batch.id === id);
      if (isChecked) {
        setCheckedBatches(checkedBatches.filter((batch) => batch.id !== id));
      } else {
        setCheckedBatches([...checkedBatches, { id, batchName }]);
      }
    }
  };

  const handleFilterStatusChecked = (id: string, value: string) => {
    if (id === "0") {
      // "All" option
      setSelectedType(
        selectedType.length === typeOptions.length
          ? []
          : [...typeOptions]
      );
    } else {
      const isChecked = selectedType.some((type) => type.id === id);
      if (isChecked) {
        setSelectedType(selectedType.filter((type) => type.id !== id));
      } else {
        const typeOption = typeOptions.find((type) => type.id === id);
        if (typeOption) {
          setSelectedType([...selectedType, typeOption]);
        }
      }
    }
  };

  const onCancel = () => {
    setCancel(false);
  };

  const noCancelModal = () => {
    setCancel(false);
  };

  const yesCancelModal = () => {
    setCancel(false);
    dispatch(resetWholeReportData());
    location?.state?.from === "RecentReports"
      ? navigate("/app/Reports/RecentReports")
      : location?.state?.from === "CreatedByMe"
        ? navigate("/app/Reports/CreatedByMe")
        : navigate("/app/Reports/AllReports");
  };

  const pageBack = () => {
    dispatch(resetWholeReportData());
    location?.state?.from === "RecentReports"
      ? navigate("/app/Reports/RecentReports")
      : location?.state?.from === "CreatedByMe"
        ? navigate("/app/Reports/CreatedByMe")
        : navigate("/app/Reports/AllReports");
  };

  const handleResetFilter = () => {
    dispatch(resetWholeReportData());
    setFiltersApplied(false);
    setCheckedBranches([]);
    setCheckedBatches([]);
    setCheckedCourses([]);
    setCheckedCountry(null);
    setSelectedMonth([]);
    setSelectedYear([]);
    setSelectedType([]);
    setSelectedMonths({});
    setStartDate(null);
    setEndDate(null);
    setIncludeAdditionalPayment(false);

    setCountrySearchTerm("");
    setBranchSearchTerm("");
    setCourseSearchTerm("");
    setBatchSearchTerm("");
    setStatusSearchTerm("");

    setIsCountryOpen(false);
    setIsBranchOpen(false);
    setIsCourseOpen(false);
    setIsBatchOpen(false);
    setIsStatusOpen(false);
    setIsDateOpen(false);
    setIsAdditionalPaymentOpen(false);
  };

  const monthNameToNumber: Record<string, number> = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  const convertMonthYearData = (data: Record<string, string[]>) => {
    return Object.entries(data).map(([year, months]) => ({
      year: Number(year),
      month: months.map((m) => monthNameToNumber[m]).filter(Boolean),
    }));
  };

  const numberToMonthName = Object.fromEntries(
    Object.entries(monthNameToNumber).map(([name, num]) => [num, name])
  );

  const handleFilterApply = () => {
    if (reportType === "") {
      dispatch(
        setToastNotification({
          message: "Please select a report type",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (!checkedCountry) {
      dispatch(
        setToastNotification({
          message: "Please select a country",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (checkedBranches?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select branch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (selectedType?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select type",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "BATCH_LEVEL" && checkedCourses?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select course filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "BATCH_LEVEL" && checkedBatches?.length === 0) {
      dispatch(
        setToastNotification({
          message: "Please select batch filter",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "MONTH_LEVEL" && !startDate) {
      dispatch(
        setToastNotification({
          message: "Please select start date",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "MONTH_LEVEL" && !endDate) {
      dispatch(
        setToastNotification({
          message: "Please select end date",
          type: "error",
          snackOpen: true,
        })
      );
    } else if (reportType === "MONTH_LEVEL" && startDate && endDate && dayjs(endDate).isBefore(dayjs(startDate), 'day')) {
      dispatch(
        setToastNotification({
          message: "End date must be after or equal to start date",
          type: "error",
          snackOpen: true,
        })
      );
    } else {
      const data: any = {
        reportType: "REVENUE",
        instituteId: activeInstitute?.id,
        generateReports: true,
        reportSubType: reportType,
        branchCountry: checkedCountry?.name,
        branchId: checkedBranches?.map((d: any) => d?.id),
        includeRandomPayment: includeAdditionaPayment,
        enquiryStatus: selectedType?.map((type) => type.id),
      };

      if (reportType === "BATCH_LEVEL") {
        data.courseId = checkedCourses?.map((d: any) => d?.id);
        data.batchId = checkedBatches?.map((d: any) => d?.id);
      }

      if (reportType === "MONTH_LEVEL") {
        data.startDate = dayjs(startDate).startOf('day').valueOf();
        data.endDate = dayjs(endDate).endOf('day').valueOf();
      }
      dispatch<any>(getReportData(data));
      setFiltersApplied(true);
      if (reportType === "BATCH_LEVEL") {
        setCollapseGraph(true);
      }
    }
  };

  const handleSaveClick = async (event: any) => {
    event.preventDefault();

    const appliedFilterCopy = [...reportWholeData.appliedFilter];

    if (includeAdditionaPayment) {
      appliedFilterCopy.push({ includeRandomPayment: true });
    }

    const updatedReportData = {
      ...reportWholeData,
      appliedFilter: appliedFilterCopy,
    };

    const data = {
      instituteId: activeInstitute?.id,
      name: reportName,
      category: "REVENUE",
      description: description,
      reportData: updatedReportData,
      createdById: user?.institute[0]?.id,
      createdByName: `${user?.institute[0]?.firstName} ${user?.institute[0]?.lastName}`,
    };
    dispatch<any>(saveReport(data));
  };

  const handleDownload = () => {
    const data = {
      action: "DOWNLOAD",
      reportType: "REVENUE",
      reportData: {
        paymentData: reportWholeData?.paymentData,
        overDue: reportWholeData?.overDue,
        pendingdata: reportWholeData?.pendingdata,
        upcomingData: reportWholeData?.upcomingData,
      },
    };
    setDownloadLoading(true);
    DownloadReport(data)
      .then((res: any) => {
        const blob = base64ToBlob(
          res?.data?.data?.fileBase64String,
          "application/vnd.ms-excel"
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "RevenueReport.xlsx";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        dispatch(
          setToastNotification({
            message: "Congratulations! Report is successfully downloaded.",
            type: "success",
            snackOpen: true,
          })
        );
        setDownloadLoading(false);
      })
      .catch((err: any) => {
        setDownloadLoading(false);
      });
  };

  const base64ToBlob = (base64Data: string, contentType: any) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const findNamesbyId = (fieldName: any, id: string) => {
    if (fieldName === "COURSE" && id) {
      const courseName = courses?.filter(
        (d: any) =>
          d?.id.toString().toLowerCase() === id.toString().toLowerCase()
      );
      return courseName && courseName[0]?.courseName;
    } else if (fieldName === "BATCH" && id) {
      const batchName = batchList?.filter(
        (d: any) =>
          d?.id.toString().toLowerCase() === id.toString().toLowerCase()
      );

      return batchName && batchName[0]?.batchName;
    } else if (fieldName === "BRANCH" && id) {
      const branchName = filteredBranches?.filter((d: any) => d?.id === id);
      return branchName && branchName[0]?.branchName;
    }
  };

  // useEffect(() => {
  //   if (add) {
  //     const getBranch = branches?.find(
  //       (item: any) => item?.id === userById?.branchId
  //     );

  //     const currentMonth = dayjs().month() + 1;
  //     const currentYear = dayjs().year();
  //     const data = {
  //       reportType: "REVENUE",
  //       instituteId: activeInstitute?.id,
  //       generateReports: true,
  //       branchId: "ALL",
  //       reportSubType: "MONTH_LEVEL",
  //       branchCountry: getBranch?.country,
  //       // month: currentMonth,
  //       // year: currentYear,
  //       monthYear: convertMonthYearData(selectedMonths),
  //       includeRandomPayment: includeAdditionaPayment,
  //       enquiryStatus: ["ACTIVE", "LOST"],
  //     };

  //     if (hasAllBranchAccess) {
  //       dispatch<any>(getReportData(data));
  //     } else {
  //       const ownBranchData = {
  //         reportType: "REVENUE",
  //         reportSubType: "MONTH_LEVEL",
  //         instituteId: activeInstitute?.id,
  //         generateReports: true,
  //         branchCountry: getBranch?.country,
  //         branchId: filteredBranches?.map((d: any) => {
  //           return d?.id;
  //         }),
  //         // month: currentMonth,
  //         // year: currentYear,
  //         monthYear: convertMonthYearData(selectedMonths),
  //         includeRandomPayment: includeAdditionaPayment,
  //       };
  //       dispatch<any>(getReportData(ownBranchData));
  //     }
  //   } else {
  //     const pathname = window.location.pathname;
  //     const reportId = pathname.substring(pathname.lastIndexOf("/") + 1);
  //     dispatch<any>(getReportById(reportId));
  //   }
  // }, [branches, userById]);
  // 1️⃣ Run initial data load ONCE when all required data is ready
  useEffect(() => {
    if (!branches?.length || !userById?.branchId) return; // wait until both exist

    if (add) {
      if (!startDate || !endDate) return;

      const getBranch = branches.find(
        (item: any) => item.id === userById.branchId
      );

      const data = {
        reportType: "REVENUE",
        instituteId: activeInstitute?.id,
        generateReports: true,
        branchId: "ALL",
        reportSubType: "MONTH_LEVEL",
        branchCountry: getBranch?.country,
        startDate: startDate.valueOf(),
        endDate: endDate.valueOf(),
        includeRandomPayment: includeAdditionaPayment,
        enquiryStatus: ["ACTIVE", "LOST"],
      };

      if (hasAllBranchAccess) {
        dispatch<any>(getReportData(data));
      } else {
        const ownBranchData = {
          ...data,
          branchId: filteredBranches?.map((d: any) => d.id),
        };
        dispatch<any>(getReportData(ownBranchData));
      }
      setFiltersApplied(true);
    } else {
      const reportId = window.location.pathname.split("/").pop();
      if (reportId) {
        dispatch<any>(getReportById(reportId));
      }
    }

  }, [add, branches?.length, userById?.branchId]);

  // useEffect(() => {
  //   if (
  //     reportWholeData?.appliedFilter ||
  //     reportById?.reportData?.appliedFilter
  //   ) {
  //     const dataFromNavigateion = add
  //       ? reportWholeData?.appliedFilter
  //       : reportById?.reportData?.appliedFilter;
  //     const branchIdArray = dataFromNavigateion?.find(
  //       (item: any) => item.branchId
  //     )?.branchId;
  //     const batchIdArray = dataFromNavigateion?.find(
  //       (item: any) => item.batchId
  //     )?.batchId;
  //     const courseIdArray = dataFromNavigateion?.find(
  //       (item: any) => item.courseId
  //     )?.courseId;
  //     const countryCheck = dataFromNavigateion?.find(
  //       (item: any) => item.branchCountry
  //     )?.branchCountry;
  //     const months = getMonths();
  //     // const month = dataFromNavigateion?.find((item: any) => item.month)?.month;
  //     const month = dataFromNavigateion?.find(
  //       (item: any) => item.durationFilter
  //     )?.durationFilter;

  //     const year = dataFromNavigateion?.find((item: any) => item.year)?.year;

  //     const reportSubType = add
  //       ? reportWholeData?.type
  //       : reportById?.reportData?.type;

  //     if (!add) {
  //       const randomPaymentIncluded = dataFromNavigateion?.find(
  //         (item: any) => item.includeRandomPayment
  //       )?.includeRandomPayment;
  //       setIncludeAdditionalPayment(randomPaymentIncluded);
  //     }
  //     const filterBranches = branches?.filter(
  //       (item: any) => item?.country === countryCheck
  //     );
  //     const filterBatches = batchList?.filter(
  //       (batch: any) =>
  //         batch.batchConductType === "REGULAR_BATCH" &&
  //         /* batch.batchStatus === 'COMPLETED' && */
  //         batch.batchStatus !== "CANCELLED" &&
  //         batch.status === "ACTIVE" &&
  //         (hasAllBranchAccess || batch?.branchId === userById?.branchId) &&
  //         filterBranches?.some((branch: any) => branch.id === batch.branchId)
  //     );
  //     if (month && !add) {
  //       // const selectedMonthObj = months?.find((m) => m.id === month);
  //       // if (selectedMonthObj) {
  //       //   setSelectedMonth([selectedMonthObj]);
  //       // }
  //       const grouped = month?.reduce((acc: any, item: any) => {
  //         const [month, year] = item.split("-").map(Number);
  //         const found = acc.find((entry: any) => entry.year === year);
  //         if (found) {
  //           found.month.push(month);
  //         } else {
  //           acc.push({ year, month: [month] });
  //         }
  //         return acc;
  //       }, []);

  //       setSelectedMonths({ monthYear: grouped });
  //     }
  //     // if (year) {
  //     //   setSelectedYear([year]);
  //     // }

  //     if (reportSubType) {
  //       setReportType(reportSubType);
  //     }
  //     if (countryCheck) {
  //       setCheckedCountry([{ name: countryCheck }]);
  //       setAppliedCountry([{ name: countryCheck }]);
  //     }

  //     if (
  //       branchIdArray === "ALL" ||
  //       branchIdArray?.length === filterBranches?.length
  //     ) {
  //       const alllBranches =
  //         filterBranches?.map((d: any) => {
  //           return { id: d?.id, branchName: d?.branchName };
  //         }) || [];
  //       setCheckedBranches([...alllBranches]);
  //     } else {
  //       const aa = branchIdArray?.map((d: any) => {
  //         return { id: d, branchName: findNamesbyId("BRANCH", d) };
  //       });
  //       setCheckedBranches(aa);
  //     }
  //     if (
  //       batchIdArray === "ALL" ||
  //       batchIdArray?.length === filterBatches?.length
  //     ) {
  //       const alllBatches =
  //         filterBatches?.map((d: any) => {
  //           return { id: d?.id, batchName: d?.batchName };
  //         }) || [];
  //       setCheckedBatches([...alllBatches]);
  //     } else {
  //       const aa = batchIdArray?.map((d: any) => {
  //         return { id: d, batchName: findNamesbyId("BATCH", d) };
  //       });
  //       setCheckedBatches(aa);
  //     }

  //     if (courseIdArray === "ALL") {
  //       const alllCourse =
  //         coursesList?.map((d: any) => {
  //           return { id: d?.id, courseName: d?.courseName };
  //         }) || [];
  //       setCheckedCourses([...alllCourse]);
  //     } else {
  //       const aa = courseIdArray?.map((d: any) => {
  //         return { id: d, courseName: findNamesbyId("COURSE", d) };
  //       });
  //       setCheckedCourses(aa);
  //     }
  //     setActive(0);
  //   }
  // }, [
  //   reportWholeData,
  //   reportById,
  //   add,
  //   userById,
  //   branches,
  //   batchList,
  //   courses,
  // ]);
  // 2️⃣ Handle report data AFTER it is fetched
  useEffect(() => {
    const appliedFilter = add
      ? reportWholeData?.appliedFilter
      : reportById?.reportData?.appliedFilter;

    if (!appliedFilter) return;
    const dataFromNavigation = appliedFilter;
    const branchIdArray = dataFromNavigation?.find(
      (item: any) => item.branchId
    )?.branchId;
    const batchIdArray = dataFromNavigation?.find(
      (item: any) => item.batchId
    )?.batchId;
    const courseIdArray = dataFromNavigation?.find(
      (item: any) => item.courseId
    )?.courseId;
    const countryCheck = dataFromNavigation?.find(
      (item: any) => item.branchCountry
    )?.branchCountry;
    const month = dataFromNavigation?.find(
      (item: any) => item.durationFilter
    )?.durationFilter;
    const startDateFromFilter = dataFromNavigation?.find(
      (item: any) => item.startDate
    )?.startDate;
    const endDateFromFilter = dataFromNavigation?.find(
      (item: any) => item.endDate
    )?.endDate;
    const reportSubType = add
      ? reportWholeData?.type
      : reportById?.reportData?.type;

    if (!add) {
      const randomPaymentIncluded = dataFromNavigation?.find(
        (item: any) => item.includeRandomPayment
      )?.includeRandomPayment;
      setIncludeAdditionalPayment(randomPaymentIncluded);

      if (startDateFromFilter) {
        setStartDate(dayjs(startDateFromFilter));
      }
      if (endDateFromFilter) {
        setEndDate(dayjs(endDateFromFilter));
      }
    }

    const filterBranches = branches?.filter(
      (item: any) => item?.country === countryCheck
    );
    const filterBatches = batchList?.filter(
      (batch: any) =>
        batch.batchConductType === "REGULAR_BATCH" &&
        batch.batchStatus !== "CANCELLED" &&
        batch.status === "ACTIVE" &&
        (hasAllBranchAccess || batch.branchId === userById?.branchId) &&
        filterBranches?.some((branch: any) => branch.id === batch.branchId)
    );

    // --- Set months/year ---
    if (month && !add) {
      const grouped = month?.reduce((acc: any, item: any) => {
        const [m, y] = item.split("-").map(Number);
        const found = acc.find((entry: any) => entry.year === y);
        if (found) found.month.push(m);
        else acc.push({ year: y, month: [m] });
        return acc;
      }, []);
      setSelectedMonths({ monthYear: grouped });
    }

    if (reportSubType) setReportType(reportSubType);
    if (countryCheck) {
      setCheckedCountry({ name: countryCheck });
      setAppliedCountry({ name: countryCheck });
    }

    // --- Branches ---
    if (
      branchIdArray === "ALL" ||
      branchIdArray?.length === filterBranches?.length
    ) {
      const allBranches =
        filterBranches?.map((d: any) => ({
          id: d.id,
          branchName: d.branchName,
        })) || [];
      setCheckedBranches([...allBranches]);
    } else {
      const aa = branchIdArray?.map((d: any) => ({
        id: d,
        branchName: findNamesbyId("BRANCH", d),
      }));
      setCheckedBranches(aa);
    }

    // --- Batches ---
    if (
      batchIdArray === "ALL" ||
      batchIdArray?.length === filterBatches?.length
    ) {
      const allBatches =
        filterBatches?.map((d: any) => ({
          id: d.id,
          batchName: d.batchName,
        })) || [];
      setCheckedBatches([...allBatches]);
    } else {
      const aa = batchIdArray?.map((d: any) => ({
        id: d,
        batchName: findNamesbyId("BATCH", d),
      }));
      setCheckedBatches(aa);
    }

    // --- Courses ---
    if (courseIdArray === "ALL") {
      const allCourses =
        coursesList?.map((d: any) => ({
          id: d.id,
          courseName: d.courseName,
        })) || [];
      setCheckedCourses([...allCourses]);
    } else {
      const aa = courseIdArray?.map((d: any) => ({
        id: d,
        courseName: findNamesbyId("COURSE", d),
      }));
      setCheckedCourses(aa);
    }

    setActive(0);
  }, [reportWholeData?.appliedFilter, reportById?.reportData?.appliedFilter]);

  React.useEffect(() => {
    if (saveReportSuccess !== false && saveReportSuccess !== false) {
      dispatch(resetReportStatuses());
      dispatch(resetWholeReportData());
      navigate(`/app/Reports/RecentReports`);
    }
  }, [saveReportSuccess]);

  React.useEffect(() => {
    const hasFilters =
      checkedCountry !== null ||
      checkedBranches?.length > 0 ||
      checkedCourses?.length > 0 ||
      checkedBatches?.length > 0 ||
      selectedType?.length < typeOptions?.length ||
      startDate !== null ||
      endDate !== null ||
      includeAdditionaPayment;

    setShowClearAll(hasFilters);
  }, [
    checkedCountry,
    checkedBranches,
    checkedCourses,
    checkedBatches,
    selectedType,
    startDate,
    endDate,
    includeAdditionaPayment,
    typeOptions
  ]);

  React.useEffect(() => {
    if (prevLeadModalState === true && leadModalState === false && filtersApplied) {
      const data: any = {
        reportType: "REVENUE",
        instituteId: activeInstitute?.id,
        generateReports: true,
        reportSubType: reportType,
        branchCountry: checkedCountry?.name,
        branchId: checkedBranches?.map((d: any) => d?.id),
        includeRandomPayment: includeAdditionaPayment,
        enquiryStatus: selectedType?.map((type) => type.id),
      };

      if (reportType === "BATCH_LEVEL") {
        data.courseId = checkedCourses?.map((d: any) => d?.id);
        data.batchId = checkedBatches?.map((d: any) => d?.id);
      }

      if (reportType === "MONTH_LEVEL") {
        data.startDate = dayjs(startDate).startOf('day').valueOf();
        data.endDate = dayjs(endDate).endOf('day').valueOf();
      }

      dispatch<any>(getReportData(data));
    }

    setPrevLeadModalState(leadModalState);
  }, [leadModalState, prevLeadModalState, filtersApplied, reportType, checkedCountry, checkedBranches, includeAdditionaPayment, selectedType, checkedCourses, checkedBatches, startDate, endDate, activeInstitute?.id, dispatch]);

  const onTypeChange = React.useCallback((event: any, value: any) => {
    setSelectedType(Array.isArray(value) ? value : value ? [value] : []);
  }, []);

  return (
    <Box
      sx={{
        overflow: "hidden",
        padding: "14px 16px",
        background: "#EEEEEE",
        maxHeight: "90vh",
        position: "relative",
        scrollbarWidth: "none",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#F5F5F5",
          display: "flex",
          width: "100%",
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "100vh",
          minHeight: "100vh",
          scrollbarWidth: "none",
        }}
      >
        {/* Left Sidebar - Filters */}
        {showFilters && (
          <Box
            sx={{
              background: "#fff",
              minWidth: "219px",
              maxWidth: "219px",
              borderRight: "1px solid #E9E9E9",
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
            }}
            className="datepicker-container"
          >
            {/* Filter Header */}
            <div className={styles.calendarHeader}>
              <div className={styles.headerText}>Custom</div>
            </div>

            {/* Apply/Clear Section */}
            {add && (
              <div className={styles.applyClearSection}>
                {showClearAll ? (
                  <div
                    className={styles.clearFilterText}
                    onClick={() => {
                      handleResetFilter();
                    }}
                  >
                    Clear All
                  </div>
                ) : (
                  <div className={styles.clearFilterText}></div>
                )}
                <div
                  className={styles.applyFilterText}
                  onClick={() => {
                    handleFilterApply();
                    // Close all accordions after apply
                    setIsCountryOpen(false);
                    setIsBranchOpen(false);
                    setIsCourseOpen(false);
                    setIsBatchOpen(false);
                    setIsStatusOpen(false);
                    setIsDateOpen(false);
                    setIsAdditionalPaymentOpen(false);
                  }}
                >
                  Apply
                </div>
              </div>
            )}

            <div
              className={styles.filterContainer}
              style={{
                flex: 1,
                overflowY: "auto",
                height: "auto",
                maxHeight: "calc(100vh - 140px)",
                padding: "10px 10px",
                scrollbarWidth: "thin",
                transition: "none",
              }}
            >
              {/* 1. Country */}
              <CustomFilterAccordion
                title="Country"
                isOpen={isCountryOpen}
                setIsOpen={setIsCountryOpen}
                count={checkedCountry ? 1 : 0}
                disabled={!add}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={countrySearchTerm}
                    onChange={(e: any) => {
                      setCountrySearchTerm(e.target.value);
                    }}
                    placeholder="Search Country"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {/* Country options */}
                      {filteredCountriesForSearch?.map((item: any) => (
                        <FilterCheckbox
                          key={item.name}
                          keyVal={item.name}
                          checked={checkedCountry?.name === item.name}
                          checkboxFunction={() =>
                            handleFilterCountryChecked(item.name, item.name)
                          }
                          label={item?.name?.toLowerCase()}
                          fromReports={true}
                          disable={!add}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>

              {/* 2. Branch */}
              <CustomFilterAccordion
                title="Branch"
                isOpen={isBranchOpen}
                setIsOpen={setIsBranchOpen}
                count={checkedBranches?.length}
                disabled={!add}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={branchSearchTerm}
                    onChange={(e: any) => {
                      setBranchSearchTerm(e.target.value);
                    }}
                    placeholder="Search Branch"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {[
                        { branchName: "All", id: "0" },
                        ...filteredBranchesForSearch,
                      ]?.map((item: any) => (
                        <FilterCheckbox
                          key={item.id}
                          keyVal={item?.id}
                          checked={
                            item.id === "0"
                              ? checkedBranches?.length === filteredBranches?.length
                              : checkedBranches?.some((data) => data?.id === item?.id)
                          }
                          checkboxFunction={() =>
                            handleFilterBranchChecked(item.id, item.branchName)
                          }
                          label={item?.branchName?.toLowerCase()}
                          fromReports={true}
                          disable={!add}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>

              {/* 3. Course (only for BATCH_LEVEL) */}
              {reportType === "BATCH_LEVEL" && (
                <CustomFilterAccordion
                  title="Course"
                  isOpen={isCourseOpen}
                  setIsOpen={setIsCourseOpen}
                  count={checkedCourses?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterSearchField
                      value={courseSearchTerm}
                      onChange={(e: any) => {
                        setCourseSearchTerm(e.target.value);
                      }}
                      placeholder="Search Course"
                    />
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {[
                          { courseName: "All", id: "0" },
                          ...filteredCoursesForSearch,
                        ]?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item?.id}
                            checked={
                              item.id === "0"
                                ? checkedCourses?.length === coursesList?.length
                                : checkedCourses?.some((data) => data?.id === item?.id)
                            }
                            checkboxFunction={() =>
                              handleFilterCourseChecked(item.id, item.courseName)
                            }
                            label={item?.courseName?.toLowerCase()}
                            fromReports={true}
                            disable={!add}
                          />
                        ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
              )}

              {/* 4. Batch (only for BATCH_LEVEL) */}
              {reportType === "BATCH_LEVEL" && (
                <CustomFilterAccordion
                  title="Batch"
                  isOpen={isBatchOpen}
                  setIsOpen={setIsBatchOpen}
                  count={checkedBatches?.length}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <FilterSearchField
                      value={batchSearchTerm}
                      onChange={(e: any) => {
                        setBatchSearchTerm(e.target.value);
                      }}
                      placeholder="Search Batch"
                    />
                    <FilterCheckBoxWrap>
                      <FormGroup>
                        {[
                          { batchName: "All", id: "0" },
                          ...filteredBatchForSearch,
                        ]?.map((item: any) => (
                          <FilterCheckbox
                            key={item.id}
                            keyVal={item?.id}
                            checked={
                              item.id === "0"
                                ? checkedBatches?.length === filteredBatch?.length
                                : checkedBatches?.some((data) => data?.id === item?.id)
                            }
                            checkboxFunction={() =>
                              handleFilterBatchChecked(item.id, item.batchName)
                            }
                            label={item?.batchName?.toLowerCase()}
                            fromReports={true}
                            disable={!add}
                            isBatchCompleted={
                              item?.batchStatus === "COMPLETED" ? true : false
                            }
                          />
                        ))}
                      </FormGroup>
                    </FilterCheckBoxWrap>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
              )}

              {/* 5. Status */}
              <CustomFilterAccordion
                title="Status"
                isOpen={isStatusOpen}
                setIsOpen={setIsStatusOpen}
                count={selectedType?.length}
                disabled={!add}
              >
                <FilterTypeWrap>
                  <FilterSearchField
                    value={statusSearchTerm}
                    onChange={(e: any) => {
                      setStatusSearchTerm(e.target.value);
                    }}
                    placeholder="Search Status"
                  />
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      {[
                        { value: "All", id: "0" },
                        ...filteredStatusForSearch,
                      ]?.map((item: any) => (
                        <FilterCheckbox
                          key={item.id}
                          keyVal={item?.id}
                          checked={
                            item.id === "0"
                              ? selectedType?.length === typeOptions?.length
                              : selectedType?.some((data) => data?.id === item?.id)
                          }
                          checkboxFunction={() =>
                            handleFilterStatusChecked(item.id, item.value)
                          }
                          label={item?.value?.toLowerCase()}
                          fromReports={true}
                          disable={!add}
                        />
                      ))}
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>

              {/* 6. Date Selection (only for MONTH_LEVEL) */}
              {reportType === "MONTH_LEVEL" && (
                <CustomFilterAccordion
                  title="Date Range"
                  isOpen={isDateOpen}
                  setIsOpen={setIsDateOpen}
                  count={startDate && endDate ? 1 : 0}
                  disabled={!add}
                >
                  <FilterTypeWrap>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Start Date"
                          value={startDate}
                          onChange={(newValue) => setStartDate(newValue)}
                          format="DD/MM/YYYY"
                          disabled={!add}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              sx: {
                                "& .MuiOutlinedInput-root": {
                                  fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                  fontSize: "14px",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="End Date"
                          value={endDate}
                          onChange={(newValue) => setEndDate(newValue)}
                          minDate={startDate}
                          format="DD/MM/YYYY"
                          disabled={!add}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              sx: {
                                "& .MuiOutlinedInput-root": {
                                  fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                  fontSize: "14px",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                  </FilterTypeWrap>
                </CustomFilterAccordion>
              )}

              {/* 7. Include Additional Payments */}
              <CustomFilterAccordion
                title="Additional Payments"
                isOpen={isAdditionalPaymentOpen}
                setIsOpen={setIsAdditionalPaymentOpen}
                count={includeAdditionaPayment ? 1 : 0}
                disabled={!add}
              >
                <FilterTypeWrap>
                  <FilterCheckBoxWrap>
                    <FormGroup>
                      <FilterCheckbox
                        keyVal="includeAdditionalPayment"
                        checked={includeAdditionaPayment}
                        checkboxFunction={() => {
                          setIncludeAdditionalPayment(!includeAdditionaPayment);
                        }}
                        label="Additional Payments"
                        fromReports={true}
                        disable={!add}
                      />
                    </FormGroup>
                  </FilterCheckBoxWrap>
                </FilterTypeWrap>
              </CustomFilterAccordion>
            </div>
          </Box>
        )}

        {/* Right Main Content Area */}
        <Box
          sx={{
            background: "#fff",
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
          }}
        >
          <div className={styles.batchHeader}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {!add && (
                <PageBackBtn
                  onClick={() => {
                    pageBack();
                  }}
                  iconOnly={true}
                />
              )}

              <div className={styles.headerText}>
                {add ? "Reports - Revenue" : `${reportById?.name}`}
              </div>
              <div className={styles.filterContainerForRevenue}>
                <Button
                  variant="contained"
                  onClick={handleClick}
                  endIcon={<ArrowDropDownIcon />}
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "13px",
                    fontWeight: "500",
                  }}
                  disabled={!add}
                >
                  {reportType?.replace(/_/g, " ").toLowerCase()}
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => handleClose(null)}
                  PaperProps={{
                    style: {
                      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                      borderRadius: "4PX",
                      border: "1px solid #E4E4E7",
                    },
                  }}
                >
                  {[{ value: "MONTH_LEVEL" }, { value: "BATCH_LEVEL" }]?.map(
                    (item: any, index: number) => (
                      <MenuItem
                        key={index}
                        onClick={() => handleReportType(item?.value)}
                        sx={{
                          textTransform: "capitalize",
                          color: "rgb(102, 112, 133)",
                        }}
                      >
                        {item?.value?.replace(/_/g, " ").toLowerCase()}
                      </MenuItem>
                    )
                  )}
                </Menu>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <button
                className={styles.graphCollapseBtn}
                onClick={() => setCollapseGraph(!collapseGraph)}
              >
                Graph{" "}
                <img
                  src={accordionDown}
                  alt=""
                  style={{
                    marginLeft: "5px",
                    transform: collapseGraph ? "rotate(180deg)" : "none",
                    transition: "0.2s ease-in-out",
                  }}
                />
              </button>
              {add && (
                <>
                  <CancelBtn
                    onClick={() => {
                      setCancel(true);
                    }}
                  />
                  <SaveBtn
                    onClick={() => {
                      setOpenSaveReportPopup(true);
                    }}
                    disabled={
                      !filtersApplied
                    }
                  />
                  <button
                    className={styles.downloadBtn}
                    onClick={() => handleDownload()}
                    disabled={
                      downloadLoading ||
                      !filtersApplied ||
                      !reportWholeData ||
                      (reportWholeData?.overDue?.length === 0 &&
                        reportWholeData?.paymentData?.length === 0 &&
                        reportWholeData?.pendingdata?.length === 0 &&
                        reportWholeData?.upcomingData?.length === 0)
                    }
                    style={{
                      opacity:
                        downloadLoading ||
                          !filtersApplied ||
                          !reportWholeData ||
                          (reportWholeData?.overDue?.length === 0 &&
                            reportWholeData?.paymentData?.length === 0 &&
                            reportWholeData?.pendingdata?.length === 0 &&
                            reportWholeData?.upcomingData?.length === 0)
                          ? 0.5
                          : 1,
                      cursor:
                        downloadLoading ||
                          !filtersApplied ||
                          !reportWholeData ||
                          (reportWholeData?.overDue?.length === 0 &&
                            reportWholeData?.paymentData?.length === 0 &&
                            reportWholeData?.pendingdata?.length === 0 &&
                            reportWholeData?.upcomingData?.length === 0)
                          ? "not-allowed"
                          : "pointer",
                      backgroundColor:
                        !filtersApplied
                          ? "#f5f5f5"
                          : "#fff",
                    }}
                  >
                    {downloadLoading ? (
                      <CircularProgress size={18} color={"inherit"} />
                    ) : (
                      <img
                        src={downloadIcon}
                        alt="downloadIcon"
                        style={{
                          opacity:
                            !filtersApplied
                              ? 0.5
                              : 1,
                        }}
                      />
                    )}
                  </button>
                </>
              )}
            </div>
          </div>

          <div
            style={{
              overflowY: "scroll",
              height: "78vh",
            }}
          >
            {add && !filtersApplied ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50vh",
                  color: "#667085",
                  fontSize: "14px",
                  fontFamily: "Poppins",
                }}
              >
                Apply filters to view the graph and table data.
              </div>
            ) : (
              <>
                <>
                  {/* Graph Section */}
                  {collapseGraph && (
                    <div
                      style={{
                        margin: collapseGraph ? "20px 20px" : "10px 20px",
                      }}
                    >
                      {reportDataloading || reportByIdLoading ? (
                        <DashboardSkeleton />
                      ) : (
                        <>
                          <div
                            className={styles.lineGraphForRevenueContainer}
                            style={{ width: "100%", marginLeft: "0px" }}
                          >
                            <div className={styles.countContainer}>
                              <div className={styles.countBox}>
                                <div className={styles.receivedHeader}>
                                  Total Received
                                </div>
                                <div
                                  className={styles.receivedCount}
                                  style={{
                                    fontFamily: "Roboto",
                                    color: "#11C89B",
                                    direction: [
                                      "Arabic",
                                      "Hebrew",
                                      "Urdu",
                                      "Farsi",
                                    ].some((lang) =>
                                      findCountryByName(
                                        appliedCountry?.name || "",
                                        countries
                                      )?.languages?.includes(lang)
                                    )
                                      ? "rtl"
                                      : "ltr",
                                  }}
                                >
                                  {
                                    findCountryByName(
                                      appliedCountry?.name || "",
                                      countries
                                    )?.currencies?.[0]?.symbol
                                  }
                                  {!add
                                    ? formatAmount(
                                      reportById?.reportData?.totalPaidRevenue
                                    )
                                    : (filtersApplied && reportWholeData?.totalPaidRevenue !== undefined)
                                      ? formatAmount(reportWholeData?.totalPaidRevenue)
                                      : formatAmount(0)}
                                </div>
                              </div>
                              <div className={styles.countBox}>
                                <div className={styles.receivedHeader}>
                                  Total Overdue
                                </div>
                                <div
                                  className={styles.receivedCount}
                                  style={{
                                    color: "#EC3939",
                                    direction: [
                                      "Arabic",
                                      "Hebrew",
                                      "Urdu",
                                      "Farsi",
                                    ].some((lang) =>
                                      findCountryByName(
                                        appliedCountry?.name || "",
                                        countries
                                      )?.languages?.includes(lang)
                                    )
                                      ? "rtl"
                                      : "ltr",
                                    fontFamily: "Roboto",
                                  }}
                                >
                                  {
                                    findCountryByName(
                                      appliedCountry?.name || "",
                                      countries
                                    )?.currencies?.[0]?.symbol
                                  }
                                  {!add
                                    ? formatAmount(
                                      reportById?.reportData?.totalOverdueRevenue
                                    )
                                    : (filtersApplied && reportWholeData?.totalOverdueRevenue !== undefined)
                                      ? formatAmount(reportWholeData?.totalOverdueRevenue)
                                      : formatAmount(0)}
                                </div>
                              </div>
                              {reportType === "MONTH_LEVEL" && (
                                <div className={styles.countBox}>
                                  <div className={styles.receivedHeader}>
                                    Total Upcoming
                                  </div>
                                  <div
                                    className={styles.receivedCount}
                                    style={{
                                      direction: [
                                        "Arabic",
                                        "Hebrew",
                                        "Urdu",
                                        "Farsi",
                                      ].some((lang) =>
                                        findCountryByName(
                                          appliedCountry?.name || "",
                                          countries
                                        )?.languages?.includes(lang)
                                      )
                                        ? "rtl"
                                        : "ltr",
                                      fontFamily: "Roboto",
                                      color: "#FFA500",
                                    }}
                                  >
                                    {
                                      findCountryByName(
                                        appliedCountry?.name || "",
                                        countries
                                      )?.currencies?.[0]?.symbol
                                    }
                                    {!add
                                      ? formatAmount(
                                        reportById?.reportData?.totalUpcomingRevenue
                                      )
                                      : (filtersApplied && reportWholeData?.totalUpcomingRevenue !== undefined)
                                        ? formatAmount(reportWholeData?.totalUpcomingRevenue)
                                        : formatAmount(0)}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div
                              className={styles.lineGraphForRevenueContainerInsider}
                              style={{
                                overflowX: "auto",
                                overflowY: "hidden",
                                scrollbarWidth: "thin",
                              }}
                            >
                              <div
                                style={{
                                  minWidth: (() => {
                                    const labelsLength = !add
                                      ? reportById?.reportData?.lineGraphData?.labels?.length
                                      : (filtersApplied && reportWholeData?.lineGraphData?.labels?.length)
                                        ? reportWholeData?.lineGraphData?.labels?.length
                                        : 0;

                                    // Improved width calculation for better visibility across all date ranges
                                    if (!labelsLength || labelsLength === 0) {
                                      return "100%";
                                    }

                                    // Calculate width based on number of data points with better scaling
                                    let widthPerBar;
                                    if (labelsLength <= 7) {
                                      widthPerBar = 80; // Weekly or less - wider bars
                                    } else if (labelsLength <= 31) {
                                      widthPerBar = 60; // Monthly - medium bars
                                    } else if (labelsLength <= 90) {
                                      widthPerBar = 45; // Quarterly - smaller bars
                                    } else {
                                      widthPerBar = 35; // Longer periods - compact bars
                                    }

                                    const calculatedWidth = labelsLength * widthPerBar;

                                    // Set reasonable bounds
                                    const minTotalWidth = 600; // Minimum total width
                                    const maxTotalWidth = 2400; // Maximum total width to prevent excessive scrolling

                                    return `${Math.max(minTotalWidth, Math.min(calculatedWidth, maxTotalWidth))}px`;
                                  })(),
                                  height: "300px",
                                }}
                              >
                                <BarChart
                                  data={
                                    (() => {
                                      if (!add) {
                                        return reportById?.reportData?.lineGraphData?.datasets;
                                      }


                                      if (!filtersApplied || !reportWholeData?.lineGraphData?.datasets) {
                                        return [];
                                      }

                                      const datasets = reportWholeData?.lineGraphData?.datasets;


                                      if (reportType === "BATCH_LEVEL" && datasets) {
                                        return datasets.filter((dataset: any) => dataset?.label !== "Upcoming");
                                      }
                                      return datasets;
                                    })()
                                  }
                                  labels={
                                    !add
                                      ? reportById?.reportData?.lineGraphData?.labels
                                      : (filtersApplied && reportWholeData?.lineGraphData?.labels)
                                        ? reportWholeData?.lineGraphData?.labels
                                        : []
                                  }
                                  place={"REVENUE_REPORT"}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </>
                <div
                  className={styles.leadsTableContainer}
                  style={{
                    margin: collapseGraph ? "30px 20px" : "10px 20px",
                  }}
                >
                  {reportDataloading || reportByIdLoading ? (
                    <>
                      <TableSkeleton />
                    </>
                  ) : (
                    <>
                      <div className={styles.toggleContainer}>
                        <PaymentStatusToggle
                          active={active}
                          setActive={setActive}
                          reportType={reportType}
                        />
                      </div>
                      {active === 0 && (
                        <RevenuePaidTab
                          tableData={
                            add
                              ? (filtersApplied && reportWholeData?.paymentData !== undefined)
                                ? reportWholeData?.paymentData
                                : []
                              : reportById?.reportData?.paymentData
                          }
                          id={activeInstitute?.id}
                        />
                      )}
                      {active === 1 && (
                        <RevenueOverdueTab
                          tableData={
                            add
                              ? (filtersApplied && reportWholeData?.overDue !== undefined)
                                ? reportWholeData?.overDue
                                : []
                              : reportById?.reportData?.overDue
                          }
                          id={activeInstitute?.id}
                        />
                      )}
                      {active === 2 && (
                        <RevenuePendingTab
                          tableData={
                            add
                              ? (filtersApplied && reportWholeData?.pendingdata !== undefined)
                                ? reportWholeData?.pendingdata
                                : []
                              : reportById?.reportData?.pendingdata
                          }
                          id={activeInstitute?.id}
                        />
                      )}
                      {active === 3 && reportType === "MONTH_LEVEL" && (
                        <RevenueUpcomingTab
                          tableData={
                            add
                              ? (filtersApplied && reportWholeData?.upcomingData !== undefined)
                                ? reportWholeData?.upcomingData
                                : []
                              : reportById?.reportData?.upcomingData
                          }
                          id={activeInstitute?.id}
                        />
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </Box>
      </Box>
      {
        openSaveReportPopup && (
          <SaveReportPopup
            openSaveReportPopup={openSaveReportPopup}
            setOpenSaveReportPopup={setOpenSaveReportPopup}
            handleSaveClick={handleSaveClick}
            saveReportLoading={saveReportLoading}
            description={description}
            setDescription={setDescription}
            reportName={reportName}
            setReportName={setReportName}
          />
        )
      }
      <CancelModal
        open={cancel}
        onClose={onCancel}
        noButtonClick={noCancelModal}
        yesButtonClick={yesCancelModal}
        subTitle=""
        title={`Do you really want to close the report without saving it!!!`}
      />
    </Box >
  );
};

export default RevenueReportCreation;
